Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var formik = require('formik');
var semanticUiReact = require('semantic-ui-react');
var _get = require('lodash/get');
var isEmpty = require('lodash/isEmpty');
var _debounce = require('lodash/debounce');
var _uniqBy = require('lodash/uniqBy');
var axios = require('axios');
var CKEditor = require('@ckeditor/ckeditor5-react');
var ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
var reactInvenioForms = require('react-invenio-forms');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var _debounce__default = /*#__PURE__*/_interopDefaultLegacy(_debounce);
var _uniqBy__default = /*#__PURE__*/_interopDefaultLegacy(_uniqBy);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var CKEditor__default = /*#__PURE__*/_interopDefaultLegacy(CKEditor);
var ClassicEditor__default = /*#__PURE__*/_interopDefaultLegacy(ClassicEditor);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var AccordionField = /*#__PURE__*/function (_Component) {
  _inherits(AccordionField, _Component);

  var _super = _createSuper(AccordionField);

  function AccordionField(_props) {
    var _this;

    _classCallCheck(this, AccordionField);

    _this = _super.call(this, _props);
    _this.iconActive = /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Icon, {
      name: "angle down",
      size: "large",
      style: {
        float: 'right'
      }
    });
    _this.iconInactive = /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Icon, {
      name: "angle right",
      size: "large",
      style: {
        float: 'right'
      }
    });

    _this.handleClick = function (showContent) {
      _this.setState({
        active: !showContent
      });
    };

    _this.renderAccordion = function (props) {
      var _this$props$ui, _this$props$ui2, _this$props$ui3;

      var _props$form = props.form,
          errors = _props$form.errors,
          status = _props$form.status;
      var active = _this.state.active;
      var hasError = status ? _this.hasError(status) : _this.hasError(errors);
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Segment, Object.assign({
        onClick: function onClick() {
          return _this.handleClick(active);
        }
      }, hasError && _objectSpread2({}, (_this$props$ui = _this.props.ui) === null || _this$props$ui === void 0 ? void 0 : _this$props$ui.error), (_this$props$ui2 = _this.props.ui) === null || _this$props$ui2 === void 0 ? void 0 : _this$props$ui2.header), /*#__PURE__*/React__default['default'].createElement("label", null, _this.props.label), /*#__PURE__*/React__default['default'].createElement("span", null, active ? _this.iconActive : _this.iconInactive)), /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Container, (_this$props$ui3 = _this.props.ui) === null || _this$props$ui3 === void 0 ? void 0 : _this$props$ui3.content, active && _this.props.children));
    };

    _this.state = {
      active: _props.active || false
    };
    return _this;
  }

  _createClass(AccordionField, [{
    key: "hasError",
    value: function hasError(errors) {
      if (this.props.fieldPath in errors) {
        return true;
      }

      for (var errorPath in errors) {
        if (errorPath.startsWith(this.props.fieldPath)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        name: this.props.fieldPath,
        component: this.renderAccordion
      });
    }
  }]);

  return AccordionField;
}(React.Component);
AccordionField.defaultProps = {
  active: false,
  label: '',
  required: false,
  ui: {
    error: {
      inverted: true,
      color: 'red',
      secondary: true
    }
  },
  optimized: false
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var FieldLabel = /*#__PURE__*/function (_Component) {
  _inherits(FieldLabel, _Component);

  var _super = _createSuper(FieldLabel);

  function FieldLabel() {
    _classCallCheck(this, FieldLabel);

    return _super.apply(this, arguments);
  }

  _createClass(FieldLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          htmlFor = _this$props.htmlFor,
          icon = _this$props.icon,
          label = _this$props.label,
          className = _this$props.className;
      return /*#__PURE__*/React__default['default'].createElement("label", {
        htmlFor: htmlFor,
        className: className
      }, icon ? /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Icon, {
        name: icon
      }) : null, label);
    }
  }]);

  return FieldLabel;
}(React.Component);
FieldLabel.defaultProps = {
  className: 'field-label-class'
};

var _excluded$9 = ["form"],
    _excluded2 = ["addButtonLabel", "children", "defaultNewValue", "fieldPath", "label", "labelIcon", "helpText"];
var ArrayField = /*#__PURE__*/function (_Component) {
  _inherits(ArrayField, _Component);

  var _super = _createSuper(ArrayField);

  function ArrayField() {
    var _this;

    _classCallCheck(this, ArrayField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.hasGroupErrors = function (errors) {
      for (var field in errors) {
        if (field.startsWith(_this.props.fieldPath)) {
          return true;
        }
      }

      return false;
    };

    _this.renderFormField = function (props) {
      var _props$form = props.form,
          values = _props$form.values,
          errors = _props$form.errors,
          arrayHelpers = _objectWithoutProperties(props, _excluded$9);

      var _this$props = _this.props,
          addButtonLabel = _this$props.addButtonLabel,
          children = _this$props.children,
          defaultNewValue = _this$props.defaultNewValue,
          fieldPath = _this$props.fieldPath,
          label = _this$props.label,
          labelIcon = _this$props.labelIcon,
          helpText = _this$props.helpText,
          uiProps = _objectWithoutProperties(_this$props, _excluded2);

      var hasError = _this.hasGroupErrors(errors) ? {
        error: {}
      } : {};
      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Field, Object.assign({}, uiProps, hasError), /*#__PURE__*/React__default['default'].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }), formik.getIn(values, fieldPath, []).map(function (value, index, array) {
        var arrayPath = fieldPath;
        var indexPath = index;
        var key = "".concat(arrayPath, ".").concat(indexPath); // TODO: Revise what we pass to children to have a nice interface
        // Passing: array, arrayHelpers, parentFieldPath, index and ...props
        //          seems enough.

        return /*#__PURE__*/React__default['default'].createElement("div", {
          key: key
        }, children(_objectSpread2({
          array: array,
          arrayHelpers: arrayHelpers,
          arrayPath: arrayPath,
          indexPath: indexPath,
          key: key
        }, props)));
      }), /*#__PURE__*/React__default['default'].createElement("label", {
        className: "helptext"
      }, helpText), /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Group, null, /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Button, {
        type: "button",
        onClick: function onClick() {
          return arrayHelpers.push(defaultNewValue);
        }
      }, /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Icon, {
        name: "add"
      }), addButtonLabel)));
    };

    return _this;
  }

  _createClass(ArrayField, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement(formik.FieldArray, {
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return ArrayField;
}(React.Component);
ArrayField.defaultProps = {
  addButtonLabel: 'Add new row',
  helpText: '',
  label: '',
  placeholder: ''
};

var BaseForm = /*#__PURE__*/function (_Component) {
  _inherits(BaseForm, _Component);

  var _super = _createSuper(BaseForm);

  function BaseForm() {
    _classCallCheck(this, BaseForm);

    return _super.apply(this, arguments);
  }

  _createClass(BaseForm, [{
    key: "render",
    value: function render() {
      var formik$1 = this.props.formik;
      return /*#__PURE__*/React__default['default'].createElement(formik.Formik, Object.assign({
        onSubmit: this.props.onSubmit
      }, formik$1), /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form, null, this.props.children));
    }
  }]);

  return BaseForm;
}(React.Component);

var _excluded$8 = ["fieldPath", "label", "optimized"];
var BooleanField = /*#__PURE__*/function (_Component) {
  _inherits(BooleanField, _Component);

  var _super = _createSuper(BooleanField);

  function BooleanField() {
    var _this;

    _classCallCheck(this, BooleanField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (props) {
      var _this$props = _this.props,
          fieldPath = _this$props.fieldPath,
          label = _this$props.label;
          _this$props.optimized;
          var uiProps = _objectWithoutProperties(_this$props, _excluded$8);

      var _props$form = props.form,
          values = _props$form.values,
          handleBlur = _props$form.handleBlur,
          errors = _props$form.errors,
          initialErrors = _props$form.initialErrors,
          initialValues = _props$form.initialValues,
          setFieldValue = _props$form.setFieldValue;
      var value = formik.getIn(values, fieldPath, false);
      var initialValue = formik.getIn(initialValues, fieldPath, false); // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field

      var fieldErrors = errors || initialValue === value && initialErrors;
      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Group, {
        inline: true
      }, /*#__PURE__*/React__default['default'].createElement("label", {
        htmlFor: fieldPath
      }, label), /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Checkbox, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: function onChange() {
          return setFieldValue(fieldPath, !value);
        },
        onBlur: handleBlur,
        checked: value,
        error: _this.renderError(fieldErrors, fieldPath)
      }, uiProps)));
    };

    return _this;
  }

  _createClass(BooleanField, [{
    key: "renderError",
    value: function renderError(errors, name) {
      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left';
      var error = errors[name];
      return error ? {
        content: error,
        pointing: direction
      } : null;
    }
  }, {
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return BooleanField;
}(React.Component);
BooleanField.defaultProps = {
  label: '',
  optimized: false
};

var ErrorLabel = /*#__PURE__*/function (_Component) {
  _inherits(ErrorLabel, _Component);

  var _super = _createSuper(ErrorLabel);

  function ErrorLabel() {
    var _this;

    _classCallCheck(this, ErrorLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (_ref) {
      var errors = _ref.form.errors;
      return _get__default['default'](errors, _this.props.fieldPath, '') ? /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Label, {
        pointing: true,
        prompt: true,
        content: _get__default['default'](errors, _this.props.fieldPath, '')
      }) : null;
    };

    return _this;
  }

  _createClass(ErrorLabel, [{
    key: "render",
    value: function render() {
      var fieldPath = this.props.fieldPath;
      return /*#__PURE__*/React__default['default'].createElement(formik.Field, {
        name: fieldPath
      }, this.renderFormField);
    }
  }]);

  return ErrorLabel;
}(React.Component);

var ErrorMessage = /*#__PURE__*/function (_Component) {
  _inherits(ErrorMessage, _Component);

  var _super = _createSuper(ErrorMessage);

  function ErrorMessage() {
    var _this;

    _classCallCheck(this, ErrorMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (_ref) {
      var errors = _ref.form.errors;
      return errors[_this.props.fieldPath] ? /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Message, {
        negative: true,
        content: errors[_this.props.fieldPath]
      }) : null;
    };

    return _this;
  }

  _createClass(ErrorMessage, [{
    key: "render",
    value: function render() {
      var fieldPath = this.props.fieldPath;
      return /*#__PURE__*/React__default['default'].createElement(formik.Field, {
        name: fieldPath
      }, this.renderFormField);
    }
  }]);

  return ErrorMessage;
}(React.Component);

var _excluded$7 = ["action", "basic", "border", "children", "fieldPath"];
var GroupField = /*#__PURE__*/function (_React$Component) {
  _inherits(GroupField, _React$Component);

  var _super = _createSuper(GroupField);

  function GroupField() {
    var _this;

    _classCallCheck(this, GroupField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.hasGroupErrors = function (errors) {
      for (var field in errors) {
        if (field.startsWith(_this.props.fieldPath)) {
          return true;
        }
      }

      return false;
    };

    _this.renderBasicField = function (action, classNames, children) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: classNames.join(' ')
      }, action && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "group-action"
      }, action), children);
    };

    _this.renderFormField = function (props) {
      var _this$props = _this.props,
          action = _this$props.action,
          basic = _this$props.basic,
          border = _this$props.border,
          children = _this$props.children,
          fieldPath = _this$props.fieldPath,
          uiProps = _objectWithoutProperties(_this$props, _excluded$7);

      var errors = formik.getIn(props, 'form.errors');
      var classNames = ['form-group'];

      if (border) {
        classNames.push('border');
      }

      if (fieldPath && _this.hasGroupErrors(errors)) {
        classNames.push('error');
      }

      if (basic) {
        return _this.renderBasicField(action, classNames, children);
      }

      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Group, Object.assign({
        className: classNames.join(' ')
      }, uiProps), action && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "group-action"
      }, action), children);
    };

    return _this;
  }

  _createClass(GroupField, [{
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return GroupField;
}(React__default['default'].Component);
GroupField.defaultProps = {
  border: false,
  optimized: false
};

var _excluded$6 = ["defaultValue", "error", "fieldPath", "label", "optimized", "options", "onChange", "onAddItem"];
var SelectField = /*#__PURE__*/function (_Component) {
  _inherits(SelectField, _Component);

  var _super = _createSuper(SelectField);

  function SelectField() {
    var _this;

    _classCallCheck(this, SelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderError = function (errors, name, value) {
      var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'above';
      var error = null;

      if (!Array.isArray(value)) {
        var options = _this.props.options;

        if (!isEmpty__default['default'](options) && !options.find(function (o) {
          return o.value === value;
        }) && !isEmpty__default['default'](value)) {
          error = "The current value \"".concat(value, "\" is invalid, please select another value.");
        }
      }

      if (!error) {
        error = errors[name];
      }

      return error ? {
        content: error,
        pointing: direction
      } : null;
    };

    _this.renderFormField = function (formikProps) {
      var _formikProps$form = formikProps.form,
          values = _formikProps$form.values,
          setFieldValue = _formikProps$form.setFieldValue,
          handleBlur = _formikProps$form.handleBlur,
          errors = _formikProps$form.errors,
          initialErrors = _formikProps$form.initialErrors,
          initialValues = _formikProps$form.initialValues;

      var _this$props = _this.props,
          defaultValue = _this$props.defaultValue,
          error = _this$props.error,
          fieldPath = _this$props.fieldPath,
          label = _this$props.label;
          _this$props.optimized;
          var options = _this$props.options,
          _onChange = _this$props.onChange,
          _onAddItem = _this$props.onAddItem,
          uiProps = _objectWithoutProperties(_this$props, _excluded$6);

      var value = formik.getIn(values, fieldPath, defaultValue);
      var initialValue = formik.getIn(initialValues, fieldPath, '');
      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Dropdown, Object.assign({
        fluid: true,
        selection: true,
        error: error || formik.getIn(errors, fieldPath, null) || // We check if initialValue changed to display the initialError,
        // otherwise it would be displayed despite updating the fieldu
        initialValue === value && formik.getIn(initialErrors, fieldPath, null),
        id: fieldPath,
        label: {
          children: label,
          htmlFor: fieldPath
        },
        name: fieldPath,
        onBlur: handleBlur,
        onChange: function onChange(event, data) {
          if (_onChange) {
            _onChange({
              event: event,
              data: data,
              formikProps: formikProps
            });
          } else {
            setFieldValue(fieldPath, data.value);
          }
        },
        onAddItem: function onAddItem(event, data) {
          if (_onAddItem) {
            _onAddItem({
              event: event,
              data: data,
              formikProps: formikProps
            });
          }
        },
        options: options,
        value: value
      }, uiProps));
    };

    return _this;
  }

  _createClass(SelectField, [{
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return SelectField;
}(React.Component);
SelectField.defaultProps = {
  defaultValue: '',
  optimized: false
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var _excluded$5 = ["fieldPath", "suggestionAPIUrl", "suggestionAPIQueryParams", "serializeSuggestions", "serializeAddedValue", "suggestionAPIHeaders", "debounceTime", "noResultsMessage", "loadingMessage", "suggestionsErrorMessage", "noQueryMessage", "fetchedOptions", "initialSuggestions", "preSearchChange", "onValueChange"];
var DEFAULT_SUGGESTION_SIZE = 20;

var serializeSuggestions = function serializeSuggestions(suggestions) {
  return suggestions.map(function (item) {
    return {
      text: item.title,
      value: item.id,
      key: item.id
    };
  });
};

var RemoteSelectField = /*#__PURE__*/function (_Component) {
  _inherits(RemoteSelectField, _Component);

  var _super = _createSuper(RemoteSelectField);

  function RemoteSelectField(props) {
    var _this;

    _classCallCheck(this, RemoteSelectField);

    _this = _super.call(this, props);

    _this.onSelectValue = function (event, _ref, callbackFunc) {
      var options = _ref.options,
          value = _ref.value;
      var selectedSuggestions = options.filter(function (item) {
        return value.includes(item.value);
      });

      _this.setState({
        selectedSuggestions: selectedSuggestions,
        searchQuery: null,
        error: false,
        open: _this.props.multiple ? true : false
      }, function () {
        return callbackFunc(_this.state.selectedSuggestions);
      });
    };

    _this.handleAddition = function (e, _ref2, callbackFunc) {
      var value = _ref2.value;
      var selectedSuggestion = _this.props.serializeAddedValue ? _this.props.serializeAddedValue(value) : {
        text: value,
        value: value,
        key: value,
        name: value
      };
      var newSelectedSuggestions = [].concat(_toConsumableArray(_this.state.selectedSuggestions), [selectedSuggestion]);

      _this.setState(function (prevState) {
        return {
          selectedSuggestions: newSelectedSuggestions,
          suggestions: _uniqBy__default['default']([].concat(_toConsumableArray(prevState.suggestions), _toConsumableArray(newSelectedSuggestions)), 'value')
        };
      }, function () {
        return callbackFunc(_this.state.selectedSuggestions);
      });
    };

    _this.onSearchChange = _debounce__default['default']( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(e, _ref3) {
        var searchQuery, query, suggestions, serializedSuggestions;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchQuery = _ref3.searchQuery;
                query = _this.props.preSearchChange(searchQuery);

                _this.setState({
                  isFetching: true,
                  searchQuery: query
                });

                _context.prev = 3;
                _context.next = 6;
                return _this.fetchSuggestions(query);

              case 6:
                suggestions = _context.sent;
                serializedSuggestions = _this.props.serializeSuggestions(suggestions);

                _this.setState(function (prevState) {
                  return {
                    suggestions: _uniqBy__default['default']([].concat(_toConsumableArray(prevState.selectedSuggestions), _toConsumableArray(serializedSuggestions)), 'value'),
                    isFetching: false,
                    error: false,
                    open: true
                  };
                });

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);

                _this.setState({
                  error: true,
                  isFetching: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }));

      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }(), _this.props.debounceTime);

    _this.fetchSuggestions = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(searchQuery) {
        var _this$props, fetchedOptions, suggestionAPIUrl, suggestionAPIQueryParams, suggestionAPIHeaders, response;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, fetchedOptions = _this$props.fetchedOptions, suggestionAPIUrl = _this$props.suggestionAPIUrl, suggestionAPIQueryParams = _this$props.suggestionAPIQueryParams, suggestionAPIHeaders = _this$props.suggestionAPIHeaders; // TODO: remove this part once backend will be implemented
                // for Subjects and Affiliations components

                if (!fetchedOptions) {
                  _context2.next = 4;
                  break;
                }

                response = {
                  data: {
                    hits: {
                      hits: fetchedOptions.filter(function (item) {
                        return item.title.toLowerCase().includes(searchQuery.toLowerCase());
                      })
                    }
                  }
                };
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    // const random_boolean = Math.random() < 0.5;
                    // if (random_boolean) {
                    //   resolve(response.data.hits.hits);
                    // } else {
                    //   reject('Something went wrong');
                    // }
                    resolve(response.data.hits.hits);
                  }, 100);
                }));

              case 4:
                return _context2.abrupt("return", axios__default['default'].get(suggestionAPIUrl, {
                  params: _objectSpread2({
                    suggest: searchQuery,
                    size: DEFAULT_SUGGESTION_SIZE
                  }, suggestionAPIQueryParams),
                  headers: suggestionAPIHeaders
                }).then(function (resp) {
                  var _resp$data, _resp$data$hits;

                  return resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : (_resp$data$hits = _resp$data.hits) === null || _resp$data$hits === void 0 ? void 0 : _resp$data$hits.hits;
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.getNoResultsMessage = function () {
      if (_this.state.isFetching) {
        return _this.props.loadingMessage;
      }

      if (_this.state.error) {
        return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Message, {
          negative: true,
          size: "mini",
          content: _this.props.suggestionsErrorMessage
        });
      }

      if (!_this.state.searchQuery) {
        return _this.props.noQueryMessage;
      }

      return _this.props.noResultsMessage;
    };

    _this.onClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.onBlur = function () {
      _this.setState(function (prevState) {
        return {
          open: false,
          error: false,
          searchQuery: null,
          suggestions: _toConsumableArray(prevState.selectedSuggestions)
        };
      });
    };

    _this.onFocus = function () {
      _this.setState({
        open: true
      });
    };

    _this.getProps = function () {
      var _this$props2 = _this.props,
          fieldPath = _this$props2.fieldPath,
          suggestionAPIUrl = _this$props2.suggestionAPIUrl,
          suggestionAPIQueryParams = _this$props2.suggestionAPIQueryParams,
          serializeSuggestions = _this$props2.serializeSuggestions,
          serializeAddedValue = _this$props2.serializeAddedValue,
          suggestionAPIHeaders = _this$props2.suggestionAPIHeaders,
          debounceTime = _this$props2.debounceTime,
          noResultsMessage = _this$props2.noResultsMessage,
          loadingMessage = _this$props2.loadingMessage,
          suggestionsErrorMessage = _this$props2.suggestionsErrorMessage,
          noQueryMessage = _this$props2.noQueryMessage,
          fetchedOptions = _this$props2.fetchedOptions,
          initialSuggestions = _this$props2.initialSuggestions,
          preSearchChange = _this$props2.preSearchChange,
          onValueChange = _this$props2.onValueChange,
          uiProps = _objectWithoutProperties(_this$props2, _excluded$5);

      var compProps = {
        fieldPath: fieldPath,
        suggestionAPIUrl: suggestionAPIUrl,
        suggestionAPIQueryParams: suggestionAPIQueryParams,
        suggestionAPIHeaders: suggestionAPIHeaders,
        serializeSuggestions: serializeSuggestions,
        serializeAddedValue: serializeAddedValue,
        debounceTime: debounceTime,
        noResultsMessage: noResultsMessage,
        loadingMessage: loadingMessage,
        suggestionsErrorMessage: suggestionsErrorMessage,
        noQueryMessage: noQueryMessage,
        fetchedOptions: fetchedOptions,
        initialSuggestions: initialSuggestions,
        preSearchChange: preSearchChange,
        onValueChange: onValueChange
      };
      return {
        compProps: compProps,
        uiProps: uiProps
      };
    };

    var _initialSuggestions = props.initialSuggestions ? props.serializeSuggestions(props.initialSuggestions) : [];

    _this.state = {
      isFetching: false,
      suggestions: _initialSuggestions,
      selectedSuggestions: _initialSuggestions,
      error: false,
      searchQuery: null,
      open: false
    };
    return _this;
  }

  _createClass(RemoteSelectField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$getProps = this.getProps(),
          compProps = _this$getProps.compProps,
          uiProps = _this$getProps.uiProps;

      return /*#__PURE__*/React__default['default'].createElement(SelectField, Object.assign({}, uiProps, {
        allowAdditions: this.state.error ? false : uiProps.allowAdditions,
        fieldPath: compProps.fieldPath,
        options: this.state.suggestions,
        noResultsMessage: this.getNoResultsMessage(),
        search: true,
        lazyLoad: true,
        open: this.state.open,
        onClose: this.onClose,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onSearchChange: this.onSearchChange,
        onAddItem: function onAddItem(_ref6) {
          var event = _ref6.event,
              data = _ref6.data,
              formikProps = _ref6.formikProps;

          _this2.handleAddition(event, data, function (selectedSuggestions) {
            if (compProps.onValueChange) {
              compProps.onValueChange({
                event: event,
                data: data,
                formikProps: formikProps
              }, selectedSuggestions);
            }
          });
        },
        onChange: function onChange(_ref7) {
          var event = _ref7.event,
              data = _ref7.data,
              formikProps = _ref7.formikProps;

          _this2.onSelectValue(event, data, function (selectedSuggestions) {
            if (compProps.onValueChange) {
              compProps.onValueChange({
                event: event,
                data: data,
                formikProps: formikProps
              }, selectedSuggestions);
            } else {
              formikProps.form.setFieldValue(compProps.fieldPath, data.value);
            }
          });
        },
        loading: this.state.isFetching
      }));
    }
  }]);

  return RemoteSelectField;
}(React.Component);
RemoteSelectField.defaultProps = {
  debounceTime: 500,
  suggestionAPIQueryParams: {},
  suggestionAPIHeaders: {},
  serializeSuggestions: serializeSuggestions,
  suggestionsErrorMessage: 'Something went wrong...',
  noQueryMessage: 'Search...',
  noResultsMessage: 'No results found.',
  loadingMessage: 'Loading...',
  preSearchChange: function preSearchChange(x) {
    return x;
  }
};

var _excluded$4 = ["fieldPath", "optimized", "error", "helpText"];
var TextField = /*#__PURE__*/function (_Component) {
  _inherits(TextField, _Component);

  var _super = _createSuper(TextField);

  function TextField(props) {
    var _this;

    _classCallCheck(this, TextField);

    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      _this.setState({
        value: e.target.value,
        valueUpdated: true
      });
    };

    _this.renderFormField = function (formikBag) {
      var _this$props = _this.props,
          fieldPath = _this$props.fieldPath;
          _this$props.optimized;
          var error = _this$props.error,
          helpText = _this$props.helpText,
          uiProps = _objectWithoutProperties(_this$props, _excluded$4);

      var _this$state = _this.state,
          value = _this$state.value,
          valueUpdated = _this$state.valueUpdated;
      var formikValue = formik.getIn(formikBag.form.values, fieldPath, '');
      var initialValue = formik.getIn(formikBag.form.initialValues, fieldPath, '');
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Input, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: _this.handleChange,
        onBlur: function onBlur(e) {
          formikBag.form.setFieldValue(fieldPath, formikValue && !valueUpdated ? formikValue : value);
          formikBag.form.handleBlur(e);
        },
        value: formikValue && !valueUpdated ? formikValue : value,
        error: error || formikValue === value && formik.getIn(formikBag.form.errors, fieldPath, null) || // We check if initialValue changed to display the initialError,
        // otherwise it would be displayed despite updating the field
        initialValue === value && formik.getIn(formikBag.form.initialErrors, fieldPath, null)
      }, uiProps)), /*#__PURE__*/React__default['default'].createElement("label", {
        className: "helptext"
      }, helpText));
    };

    _this.state = {
      value: '',
      valueUpdated: false
    };
    return _this;
  }

  _createClass(TextField, [{
    key: "render",
    value: function render() {
      /*
       * TextField manages the value internally using the components
       * state instead of formik's state to avoid slowness.
       * Do not change to FastField or this won't work!
       */
      return /*#__PURE__*/React__default['default'].createElement(formik.Field, {
        id: this.props.fieldPath,
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return TextField;
}(React.Component);
TextField.defaultProps = {
  optimized: false,
  helpText: ''
};

var _excluded$3 = ["fieldPath", "optimized"];
var TextAreaField = /*#__PURE__*/function (_Component) {
  _inherits(TextAreaField, _Component);

  var _super = _createSuper(TextAreaField);

  function TextAreaField() {
    var _this;

    _classCallCheck(this, TextAreaField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (formikBag) {
      var _this$props = _this.props,
          fieldPath = _this$props.fieldPath;
          _this$props.optimized;
          var uiProps = _objectWithoutProperties(_this$props, _excluded$3);

      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Field, {
        id: fieldPath
      }, /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.TextArea, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: formikBag.form.handleChange,
        onBlur: formikBag.form.handleBlur,
        value: formik.getIn(formikBag.form.values, fieldPath, '')
      }, uiProps)), /*#__PURE__*/React__default['default'].createElement(ErrorLabel, {
        fieldPath: fieldPath
      }));
    };

    return _this;
  }

  _createClass(TextAreaField, [{
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        id: this.props.fieldPath,
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return TextAreaField;
}(React.Component);
TextAreaField.defaultProps = {
  optimized: false
};

var _excluded$2 = ["name", "content", "isDisabled"];
var ActionButton = /*#__PURE__*/function (_Component) {
  _inherits(ActionButton, _Component);

  var _super = _createSuper(ActionButton);

  function ActionButton() {
    _classCallCheck(this, ActionButton);

    return _super.apply(this, arguments);
  }

  _createClass(ActionButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          name = _this$props.name,
          content = _this$props.content,
          isDisabled = _this$props.isDisabled,
          uiProps = _objectWithoutProperties(_this$props, _excluded$2);

      return /*#__PURE__*/React__default['default'].createElement(formik.Field, null, function (_ref) {
        var formik = _ref.form;
        return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Button, Object.assign({
          disabled: isDisabled ? isDisabled(formik) : false,
          name: name,
          content: content,
          type: "button"
        }, uiProps, {
          // able to override above props
          onClick: function onClick(e) {
            return _this.props.onClick(e, formik);
          }
        }), _this.props.children ? _this.props.children(formik) : null);
      });
    }
  }]);

  return ActionButton;
}(React.Component);

var _excluded$1 = ["checked", "fieldPath", "label", "labelIcon", "onChange", "optimized", "value"];
var RadioField = /*#__PURE__*/function (_Component) {
  _inherits(RadioField, _Component);

  var _super = _createSuper(RadioField);

  function RadioField() {
    var _this;

    _classCallCheck(this, RadioField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (formikProps) {
      /** Radio Formik + Semantic-UI Field Component
       *
       * NOTE: renderFormField is run multiple times
       * TODO: might gain performance by extracting it out as own component and
       *       using class methods
       *
       * field: current Formik field (RadioField instance)
       * form: current Formik form (holds formik state that drives the UI)
       */
      var _this$props = _this.props,
          checked = _this$props.checked,
          fieldPath = _this$props.fieldPath,
          label = _this$props.label,
          labelIcon = _this$props.labelIcon;
          _this$props.onChange;
          _this$props.optimized;
          var value = _this$props.value,
          uiProps = _objectWithoutProperties(_this$props, _excluded$1);

      var handleChange = function handleChange(event, data) {
        if (_this.props.onChange) {
          _this.props.onChange({
            event: event,
            data: data,
            formikProps: formikProps
          });
        } else {
          formikProps.form.setFieldValue(fieldPath, value);
        }
      };

      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Radio, Object.assign({
        name: fieldPath,
        label: /*#__PURE__*/React__default['default'].createElement(FieldLabel, {
          htmlFor: fieldPath,
          icon: labelIcon,
          label: label
        }),
        value: formik.getIn(formikProps.form.values, fieldPath, ''),
        checked: checked,
        onChange: handleChange
      }, uiProps));
    };

    return _this;
  }

  _createClass(RadioField, [{
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return RadioField;
}(React.Component);
RadioField.defaultProps = {
  checked: false,
  label: '',
  optimized: false
};

var RichInputField = /*#__PURE__*/function (_Component) {
  _inherits(RichInputField, _Component);

  var _super = _createSuper(RichInputField);

  function RichInputField() {
    var _this;

    _classCallCheck(this, RichInputField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (formikBag) {
      var _this$props = _this.props,
          editorConfig = _this$props.editorConfig,
          fieldPath = _this$props.fieldPath,
          label = _this$props.label,
          required = _this$props.required;
      var value = formik.getIn(formikBag.form.values, fieldPath, '');
      var initialValue = formik.getIn(formikBag.form.initialValues, fieldPath, '');
      var error = formik.getIn(formikBag.form.errors, fieldPath, false) || // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      initialValue === value && formik.getIn(formikBag.form.initialErrors, fieldPath, false);
      return /*#__PURE__*/React__default['default'].createElement(semanticUiReact.Form.Field, {
        id: fieldPath,
        required: required,
        error: error
      }, React__default['default'].isValidElement(label) ? label : /*#__PURE__*/React__default['default'].createElement("label", {
        htmlFor: fieldPath
      }, label), /*#__PURE__*/React__default['default'].createElement(CKEditor__default['default'], {
        editor: ClassicEditor__default['default'],
        config: editorConfig,
        data: value,
        onBlur: function onBlur(event, editor) {
          formikBag.form.setFieldValue(fieldPath, editor.getData());
          formikBag.form.setFieldTouched(fieldPath, true);
        }
      }), /*#__PURE__*/React__default['default'].createElement(reactInvenioForms.ErrorLabel, {
        fieldPath: fieldPath
      }));
    };

    return _this;
  }

  _createClass(RichInputField, [{
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        id: this.props.fieldPath,
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return RichInputField;
}(React.Component);
RichInputField.defaultProps = {
  optimized: false,
  editorConfig: {}
};

var _excluded = ["onValue", "offValue", "onLabel", "offLabel", "fieldPath", "onChange", "optimized"];
var ToggleField = /*#__PURE__*/function (_Component) {
  _inherits(ToggleField, _Component);

  var _super = _createSuper(ToggleField);

  function ToggleField() {
    var _this;

    _classCallCheck(this, ToggleField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderFormField = function (formikProps) {
      /** Radio toggle Formik + Semantic-UI Field Component
       *
       * NOTE: renderFormField is run multiple times
       * TODO: might gain performance by extracting it out as own component and
       *       using class methods
       *
       * formikProps: current Formik props (ToggleField instance)
       */
      var _this$props = _this.props,
          onValue = _this$props.onValue,
          offValue = _this$props.offValue,
          onLabel = _this$props.onLabel,
          offLabel = _this$props.offLabel,
          fieldPath = _this$props.fieldPath,
          onChange = _this$props.onChange;
          _this$props.optimized;
          var uiProps = _objectWithoutProperties(_this$props, _excluded);

      var isChecked = formik.getIn(formikProps.form.values, fieldPath) === onValue;

      var handleChange = function handleChange(_ref) {
        _ref.data;

        if (isChecked) {
          formikProps.form.setFieldValue(fieldPath, offValue);
        } else {
          formikProps.form.setFieldValue(fieldPath, onValue);
        }

        if (onChange) {
          onChange({
            checked: !isChecked
          });
        }
      };

      return /*#__PURE__*/React__default['default'].createElement(RadioField, Object.assign({}, uiProps, {
        toggle: true,
        fieldPath: fieldPath,
        checked: formik.getIn(formikProps.form.values, fieldPath) === onValue,
        label: formik.getIn(formikProps.form.values, fieldPath) === onValue ? onLabel : offLabel,
        onChange: handleChange
      }));
    };

    return _this;
  }

  _createClass(ToggleField, [{
    key: "render",
    value: function render() {
      var FormikField = this.props.optimized ? formik.FastField : formik.Field;
      return /*#__PURE__*/React__default['default'].createElement(FormikField, {
        name: this.props.fieldPath,
        component: this.renderFormField
      });
    }
  }]);

  return ToggleField;
}(React.Component);
ToggleField.defaultProps = {
  optimized: true
};

exports.AccordionField = AccordionField;
exports.ActionButton = ActionButton;
exports.ArrayField = ArrayField;
exports.BaseForm = BaseForm;
exports.BooleanField = BooleanField;
exports.ErrorLabel = ErrorLabel;
exports.ErrorMessage = ErrorMessage;
exports.FieldLabel = FieldLabel;
exports.GroupField = GroupField;
exports.RadioField = RadioField;
exports.RemoteSelectField = RemoteSelectField;
exports.RichInputField = RichInputField;
exports.SelectField = SelectField;
exports.TextAreaField = TextAreaField;
exports.TextField = TextField;
exports.ToggleField = ToggleField;
//# sourceMappingURL=index.js.map
